// Foundation only: no request detection, cookies, redirects or app integration.
export const SUPPORTED_LOCALES = Object.freeze(["en", "zh-Hans"] as const);
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

export const LOCALE_CONFIG = Object.freeze({
  en: Object.freeze({ label: "English", publicPrefix: "" }),
  "zh-Hans": Object.freeze({ label: "简体中文", publicPrefix: "/zh" }),
});

export function isLocale(value: unknown): value is Locale {
  return value === "en" || value === "zh-Hans";
}

// Invalid values never silently become English or an unvalidated import path.
export function requireLocale(value: unknown): Locale {
  if (!isLocale(value)) {
    throw new TypeError("Unsupported locale. Expected en or zh-Hans.");
  }
  return value;
}
